<template lang="pug">
.data-table-items-per-page
  UiStack(spacing="sm")
    .data-table-items-per-page__label
      | {{ $t("pagination.per_page") }}
    .data-table-items-per-page__select
      UiMultiselect(
        v-model="perPageModel"
        :options="perPageOptions"
        :allowEmpty="false"
        :size="size"
        :canClear="false"
        :appendToBody="attachDropdownToBody"
        :canDeselect="false"
      )
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["update:modelValue"],

  props: {
    size: {
      type: String,
      default: "md",
    },
    modelValue: {
      type: Number,
      default: null,
    },
    perPageOptions: {
      type: Array,
      default: () => [5, 10, 15, 25, 50, 100],
    },
    attachDropdownToBody: {
      type: Boolean,
    },
  },

  computed: {
    perPageModel: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
});
</script>

<style lang="scss">
.data-table-items-per-page {
  position: relative;

  &__select {
    .ui-multiselect-wrapper {
      padding-left: 0.75rem;
      padding-right: 2.2rem;
      min-width: 70px;
    }
  }
}
</style>
